import { forwardRef, useId } from 'react';

import type { ISelectProps } from '../../../interfaces/inputs';
import './CustomSelect.scss';

export const CustomSelect = forwardRef<HTMLSelectElement, ISelectProps>(
  (
    { id, label, helperText, error, options, placeholder, containerClassName, className, value, ...selectProps },
    ref
  ) => {
    const generatedId = useId();
    const selectId = id ?? generatedId;
    const hasError = Boolean(error);

    const fieldClassName = [
      'custom-select-field',
      hasError ? 'custom-select-field--error' : '',
      containerClassName ?? ''
    ]
      .filter(Boolean)
      .join(' ');

    const selectClassName = ['custom-select-field__select', className ?? ''].filter(Boolean).join(' ');

    return (
      <div className={fieldClassName}>
        {label && (
          <label className="custom-select-field__label" htmlFor={selectId}>
            {label}
          </label>
        )}
        <div className="custom-select-field__control">
          <select
            ref={ref}
            id={selectId}
            className={selectClassName}
            aria-invalid={hasError || undefined}
            value={value ?? ''}
            {...selectProps}
          >
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <span className="custom-select-field__caret" aria-hidden="true">
            ▾
          </span>
        </div>
        {hasError ? (
          <div className="custom-select-field__error" role="alert">
            {error}
          </div>
        ) : (
          helperText && <div className="custom-select-field__hint">{helperText}</div>
        )}
      </div>
    );
  }
);

CustomSelect.displayName = 'CustomSelect';

export default CustomSelect;
